import {
    actionCreator,
    API_URL,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    jsonApiHeader,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage,
} from '../../../../../../actions/utilAction'




export {
    jsonApiHeader,
    showWarningMessage,
    showErrorMessage,
    actionCreator,
    checkHttpStatus,
    create_post_data,
    createSearchUrl,
    showSuccessMessage
};

export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const GET_DOMAINS_BASED_ON_CLIENT =`${API_URL}/api/MasterDataDefaultTargetSetting/GetDaomainListByClientIds`;
export const GET_CLIENT_BEHAVIOUR_LIST_DOWNLOAD = `${API_URL}/api/MasterDataDefaultTargetSetting/DownloadClientBehaviorTemplate`;
export const DOWNLOAD_CLIENT_LIST = `${API_URL}/api/MasterDataDefaultTargetSetting/DownloadClientTemplate`;
export const GET_PROGRAM_BASED_ON_CLIENT = `${API_URL}/api/MasterDataDefaultTargetSetting/GetProgramListByClientIdsAndDomainIds`;
export const DOWNLOAD_BEHAVIOR_RAW_DATA_TEMPLATE = `${API_URL}/api/MasterDataDefaultTargetSetting/DownloadBehaviorsForRawData`;

export const GET_PATIENTS_LIST_FOR_FILTER = `${API_URL}/patients/GetPatientsListForFilter`;

export const DownLoadClientListActionTypes = {
    get_masterData: createRequestActionTypes('GET_MASTERDATA'),
    downloadClientList: createRequestActionTypes('DOWNLOAD_CLIENT_LIST'),
    get_clientBehaviourListDownload: createRequestActionTypes('GET_CLIENT_BEHAVIOUR_LIST_DOWNLOAD'),
    downloadBehaviorRawDataTemplate: createRequestActionTypes('DOWNLOAD_BEHAVIOR_RAW_DATA_TEMPLATE'),
    get_DomainsList:createRequestActionTypes('GET_DOMAINS_BASED_ON_CLIENT'),
    get_ProgramList:createRequestActionTypes('GET_PROGRAM_BASED_ON_CLIENT'),
    get_PatientsList:createRequestActionTypes('GET_PATIENTS_LIST_FOR_FILTER'),
}





// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/settings/uploadExcel/downLoadClientList/constants/ApiConstants.js